import { useTranslation } from 'react-i18next';
import { useHasRole } from '../../../../api/access';
import { useIndividualKycTokenQuery } from '../../../../api/kyc';
import { SumSubStep } from './SumSubStep';
import { TextContentIsland } from '@razz-team/ui-web';
import { useCustomerQuery } from '../../../../api/customers';
import { CustomerLegalInfoStep, isLegalInfoFilled } from './CustomerLegalInfoStep';

export function OwnerVerificationStep({ onSuccess }: { onSuccess?: () => void }) {
  const { t } = useTranslation();
  const isOwner = useHasRole('OWNER');
  const tokenQuery = useIndividualKycTokenQuery();
  const customerQuery = useCustomerQuery();
  const individual = customerQuery.data?.individual;

  if (!isOwner) {
    return (
      <TextContentIsland>
        {t('Please ask the business owner to sign in and verify their identity.')}
      </TextContentIsland>
    );
  }

  if (!individual) return null;

  if (individual.state !== 'CREATED' && !isLegalInfoFilled(individual)) {
    return <CustomerLegalInfoStep individual={individual} />;
  }

  return <SumSubStep tokenQuery={tokenQuery} onSuccess={onSuccess} />;
}
